

















import { Vue, Component, Prop } from 'nuxt-property-decorator';
import UniversalSearchResultsItem from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsItem.vue';
import Avatar from '@/components/common/Avatar/Avatar.vue';
import type { User } from '@/types/graphql';

@Component<UniversalSearchResultsUser>({
  components: {
    UniversalSearchResultsItem,
    Avatar,
  },
})
export default class UniversalSearchResultsUser extends Vue {
  @Prop({ default: false }) removable!: boolean;
  @Prop({ required: true }) item!: { warRoomUser: User };

  get name() {
    return this.item.warRoomUser.username;
  }
}
